import React from 'react';

export default function MainErrorPage() {
  return (
    <div className='screen-container'>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <img src="/error.jpg" alt="Error" style={{ width: '60%', height: 'auto' }} />
    </div>

    </div>
  );
}
